// Generated by CoffeeScript 2.7.0
var OptionsMultipleSelect, list_option;

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import ChipInput from 'trunks/vue/admin/components/libs/chip_input.js';

import GroupOptions from 'trunks/vue/admin/components/libs/group_options.js';

list_option = {
  name: 'option-item',
  template: `<label
  class="list-item"
  :class='{ "disabled": optionDisabled }'
  @click='selectOptionFunc'
>
  <div class='content justify-box' v-if="option.id === 0">
    <div class="zero-flex-shrink mr-2">{{ label }}</div>
    <input type="text" v-model="option.value" placeholder="请输入">
  </div>
  <div class='content' v-else>
    <span>{{ label }}</span>
  </div>
  <i class='tip' :class="checked ? 'slp-check' : 'slp-empty'"></i>
  </div>
</label>`,
  props: ['option', 'selected'],
  data: function() {
    return {
      checked: false
    };
  },
  computed: {
    optionDisabled: function() {
      return this.option.settings.enable_modify || this.limitReached;
    },
    limitReached: function() {
      return !this.checked && this.option.limitReached();
    },
    value: function() {
      return this.option.value;
    }
  },
  watch: {
    selected: {
      handler: function(value) {
        return this.checked = value;
      },
      immediate: true
    },
    checked: function(new_val) {
      if (new_val) {
        return this.option.incrementCounter();
      } else {
        return this.option.decrementCounter();
      }
    },
    limitReached: function(new_val) {
      if (new_val) {
        return this.$nextTick(function() {
          return this.$emit('valueChange', this.option, false);
        });
      }
    },
    value: function(value) {
      if (value) {
        return this.$emit('valueChange', this.option, this.checked);
      } else {
        return this.checked = false;
      }
    }
  },
  created: function() {
    this.label = this.option.textValue(this.checked);
    if (this.checked) {
      this.option.incrementCounter();
      if (this.option.isOverLimit()) {
        return this.$nextTick(function() {
          return this.$emit('valueChange', this.option, false);
        });
      }
    }
  },
  methods: {
    selectOptionFunc: _.debounce(function(event) {
      if (this.optionDisabled) {
        return;
      }
      if (this.value) {
        this.checked = !this.checked;
        return this.$emit('valueChange', this.option, this.checked);
      }
    })
  }
};

export default OptionsMultipleSelect = Vue.extend({
  components: {
    "Popover": Popover,
    "chip-input": ChipInput,
    'option-item': list_option
  },
  template: `<Popover position="bottom"
         :caret='false'
         :blockContent='true'
         :manualToggle='true'
         customClass="popover-with-filter"
         @triggerClicked='triggerClicked'
         ref='popoverVm'>
  <template slot='trigger'>
    <chip-input
      v-if='multiple'
      :chips='selectedItems'
      nameKey='value'
      placeholder='请选择'
      @chipClicked='unselect'
      ref='chipInput'
    />
    <div v-else class='input-control right-addon justify-box'>
      <div class="controlled-input" v-if="selectedItems.length > 0">{{selectedItems[0].value}}</div>
      <div v-else class="controlled-input placeholder">请选择</div>
    </div>
    <div class="addon">
      <i class="slp-caret-down"></i>
    </div>
  </template>
  <template slot='content'>
    <div class="list-with-filter">
      <div class="filter-container">
        <input type="text" @input="inputChange" :value="filterKey" placeholder="请输入筛选" class="filter-input" />
        <div class="addon-buttons" v-if="multiple">
          <div class="btn btn-sm btn-info text-btn" @click="selectAll">全选</div>
          <div class="btn btn-sm btn-primary text-btn" @click="clearAll">清空</div>
        </div>
      </div>
      <div class='list'>
        <option-item
          v-for="option in groupedOptions"
          :key='option.id'
          :option='option'
          :selected="getOptionSelected(option)"
          @valueChange="valueChangedFunc"
        />
      </div>
    </div>
  </template>
</Popover>`,
  props: {
    options: {
      type: Array,
      default: function() {
        return [];
      }
    },
    otherOption: {
      type: Object,
      default: null
    },
    initialSelectedOptions: {
      type: Array,
      default: function() {
        return [];
      }
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      selectedItems: this.initialSelectedOptions,
      filterKey: ''
    };
  },
  computed: {
    groupedOptions: function() {
      var filterKeyValue;
      if (this.otherOption) {
        this.options.push(this.otherOption);
      }
      if (this.filterKey) {
        filterKeyValue = this.filterKey;
        return this.options.filter(function(item) {
          return item.label.includes(filterKeyValue);
        });
      } else {
        return this.options;
      }
    }
  },
  methods: {
    unselect: function(option) {
      return this.valueChangedFunc(option, false);
    },
    inputChange: function(event) {
      return this.filterKey = event.target.value.trim();
    },
    selectAll: function() {
      return this.selectedItems = _.union(this.selectedItems, this.groupedOptions);
    },
    clearAll: function() {
      return this.selectedItems = _.difference(this.selectedItems, this.groupedOptions);
    },
    valueChangedFunc: function(option, checked) {
      var unselectedItem;
      this.selectedItems = checked ? this.multiple ? _.union(this.selectedItems, [option]) : [option] : (unselectedItem = _.find(this.selectedItems, function(item) {
        return item.id === option.id;
      }), _.without(this.selectedItems, unselectedItem));
      return this.$emit('valueChange', this.selectedItems);
    },
    triggerClicked: function() {
      return this.$refs.popoverVm.open();
    },
    getOptionSelected: function(option) {
      return this.selectedItems.includes(option);
    }
  }
});
